<template>
  <div>
    <div v-if="!isInvalid" :class="readingStyle" padding>
      <h1 class="digest-title" @click="info()">
        <span v-html="this.doc.shortTitle || this.doc.title"></span>
        <span><ion-icon name="information-circle-outline"></ion-icon></span>
      </h1>
      <div class="digest-subinfo">
        <div style="margin-right: 0.5em; padding-top: 0.3em">
          <ion-icon style="margin-right: 0.2em" name="contact"></ion-icon
          >Lawyerly PH<span class="ai-badge">AI Generated</span><span class="beta-badge">BETA</span>
        </div>
      </div>
      <hr class="title-hr" />
      <div ref="rendered" v-html="rendered" class="rendered allow-select"></div>
      <br/>
      <br/>
      <br/>
      <i style="color: #e57373;">Disclaimer: This is an AI Generated digest. This is not reviewed nor edited by a human.</i>
    </div>

    <div v-else class="notebook-notice">
      <h6>Digest not found or invalid url.</h6>
    </div>

    <div v-if="popupContent">
      <div id="popupMenu" style="display: none">
        <popup-menu></popup-menu>
      </div>
    </div>
  </div>
</template>
<script>
import marked from "marked";
import Menu from "./PopupMenu";

export default {
  data() {
    return {
      popupContent: false,
      title: "",
      content: "",
      doc: {},
      isInvalid: false,
    };
  },

  methods: {
    async load(id) {
      var res = await this.$http.get(
        this.$config.api.url + "/digests/generated/" + id
      );
      if (res.data) {
        if (res.data.content) {
          this.doc = res.data.doc;
          this.content = res.data.content;
          this.initiateMenu();
          this.$root.mountPrintable(
            this.doc.title,
            this.rendered,
            "Digest | Lawyerly PH"
          );
        } else {
          this.isInvalid = true;
        }
      }
    },

    more(evt) {
      this.popupContent = false; // re-create always
      setTimeout(() => {
        this.popupContent = true;
        this.$ionic.showPopover(evt, {
          template: "popupMenu",
          translucent: true,
        });
      }, 200);
    },

    onHeaderCommand(event, cmd) {
      switch (cmd.cmd) {
        case "info":
          this.open();
          break;
        case "more":
          this.more(event);
          break;
        case "share":
          this.share();
          break;
      }
    },

    async info() {
      this.$ionic.dismissPopover();
      await this.$ionic.showAlert(
        `<div style="text-align: center;">
          <h4>${this.doc.title}</h4>
          <h6>[${this.doc.gr}, ${this.doc.date}]</h6>
          <h6>${this.doc.ponente}</h6>
          </div>`,
        {
          cssClass: "medium-width-alert",
          header: "Source",
          buttons: [
            {
              text: "View Case",
              handler: () => {
                this.open();
                return true;
              },
            },
            "Close",
          ],
        }
      );
    },

    open() {
      this.$router.push(`/cases/${this.doc.docId}`);
      this.$ionic.dismissPopover();
    },
    async share() {
      var url = window.location.href;
      shareTo(url, "Share this generated digest with your friends.");
    },
    initiateMenu() {
      let menus = [
        {
          label: "share",
          icon: "share",
          disabled: false,
          emit: "header-command",
          cmd: "share",
        },
        {
          label: "view case",
          icon: "custom-case",
          disabled: false,
          emit: "header-command",
          cmd: "info",
        },
      ];

      if (this.$route.query.u) {
        menus.splice(2, 1);
      }

      this.$store.commit("ui/setMoreHeaderButtons", {
        mobile: [
          { icon: "eye", emit: "header-command", cmd: "comments" },
          { icon: "custom-notes", emit: "header-command", cmd: "notes" },
          { icon: "more", emit: "header-command", cmd: "more" },
        ],
        web: menus,
      });
      this.$root.$on("header-command", this.onHeaderCommand);
    },
  },

  computed: {
    readingStyle() {
      return [
        "reading-" +
          (this.$store.state.settings.settings.readingMode || "normal"),
        "textsize-" +
          (this.$store.state.settings.settings.textSize || "normal"),
        "digest-content",
      ];
    },
    rendered() {
      // return this.content;
      return marked(this.content);
    },
  },

  mounted() {
    this.load(this.$store.state.route.params.id);
  },

  beforeDestroy() {
    this.$root.unMountPrintable();
    this.$store.commit("ui/setMoreHeaderButtons", { mobile: [], web: [] });
    this.$root.$off("header-command", this.onHeaderCommand);
  },

  components: {
    "popup-menu": Menu,
  },
};
</script>
<style>
.digest-content i {
  color: var(--ion-color-primary);
  font-weight: 500;
  transition: height 0.5s ease-in-out;
  display: block;
  overflow: hidden;
}

.digest-title {
  cursor: pointer;
  display: inline-block;
}

.digest-title:hover {
  text-decoration: underline;
}

.digest-title ion-icon {
  vertical-align: -3px;
}

.rendered p {
  margin: 0 0 10px;
  text-align: justify;
}
.rendered ol li {
  margin: 0 0 10px;
  text-align: justify;
}

.beta-badge {
  font-size: 11px;
  background: #ef5350;
  padding: 3px 8px;
  color: #fff;
  border-radius: 5px;
  margin-left: 7px;
  font-weight: bold;
}

.ai-badge {
  font-size: 11px;
  background: #ab47bc;
  padding: 3px 8px;
  color: #fff;
  border-radius: 5px;
  margin-left: 7px;
  font-weight: bold;
}
</style>